module.exports = __webpack_public_path__ + "static/img/price_stage_des.178fa32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price_stage_des.png
// module id = ph4j
// module chunks = 1